import { Injectable } from '@angular/core';

import { Product } from '@bytel/bytel-sales';

import { ReferrerService } from '@base/common/services/referrer.service';

import { ConfigurationService } from '@services/configuration.service';

import { PartnerOffer, PartnerOffers } from '../interfaces/partner.interface';
import { PartnerExclusivityErrorModalComponent } from '../shared/partner-exclusivity-error-modal/partner-exclusivity-error-modal.component';
import { MessageService } from './message.service';

// @dynamic
@Injectable({
    providedIn: 'root',
})
export class PartnersService extends ReferrerService {
    constructor(private configurationService: ConfigurationService, private messageService: MessageService) {
        super(document);
    }

    /**
     * Check if partner offer is valid
     * @param urlKeys url key attribut
     * @returns null if valid or partnerOffers name for error modal
     */
    public isPartnerOfferValid(urlKeys: string[]): PartnerOffer {
        const partnerOffers: PartnerOffers = this.configurationService.getData()?.global.partner?.offers || {};
        const partnerUrl: string = partnerOffers ? urlKeys.find((url) => partnerOffers[url]) : null;
        const referrers = partnerUrl ? partnerOffers[partnerUrl]?.referrer : null;
        return this.isReferrerValid(referrers) ? null : partnerOffers[partnerUrl];
    }

    public checkProductReferrer(product: Product): void {
        this._checkYamaReferrer(product);
    }

    private _checkYamaReferrer(product: Product): void {
        const yamaReferrers: string[] = this.configurationService.getData()?.global.yama?.referrers || [];
        if (product.data.banking_offer === true && !this.isReferrerValid(yamaReferrers)) {
            const err = {
                message: 'OMB exclusive offer',
                errorThrown: true,
            };
            this.messageService.openModal(PartnerExclusivityErrorModalComponent, {
                partner: 'votre espace bancaire',
            });
            throw err;
        }
    }
}
